import { createFileRoute, Outlet } from '@tanstack/react-router'
import { AdminGuard } from '@/features/admin/components/admin-guard'

export const Route = createFileRoute('/_protected/admin')({
  component: AdminLayout,
})

function AdminLayout() {
  return (
    <AdminGuard>
      <Outlet />
    </AdminGuard>
  )
}
